import { createContext, useContext } from 'react';
import type { VenueResponse } from '../features/venues/hooks/useVenues';

export const VENUE_TYPE_HINT_KEY = 'lov-venue-type-hint';

export interface VenueContextType {
  venueId: string;
  venue: VenueResponse;
  venues: VenueResponse[];
}

export const VenueContext = createContext<VenueContextType | undefined>(undefined);

/** Reads the persisted venue type hint from localStorage (no context required). */
export function useVenueTypeHint(): string | undefined {
  try {
    return localStorage.getItem(VENUE_TYPE_HINT_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function useVenueContext(): VenueContextType {
  const context = useContext(VenueContext);
  if (context === undefined) {
    throw new Error('useVenueContext must be used within a VenueLayout');
  }
  return context;
}
